import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    accessToken: null,
    appUrl: null,
    serviceUrl: null,
    sessionName: null,
    tokenExpirationDate: null,
    userId: null
};

export const sessionSlice = createSlice({

    name: "session",
    initialState,

    reducers: {
        setAccessToken: (state, action) => {
            state.accessToken = action.payload;
        },
        setAppUrl: (state, action) => {
            state.appUrl = action.payload;
        },
        setServiceUrl: (state, action) => {
            state.serviceUrl = action.payload;
        },

        setSessionName: (state, action) => {
            state.sessionName = action.payload;
        },
        setTokenExpirationDate: (state, action) => {
            state.tokenExpirationDate = action.payload;
        },
        setUserId: (state, action) => {
            state.userId = action.payload;
        }
    },

});

export const { setAccessToken, setAppUrl, setServiceUrl, setSessionName, setTokenExpirationDate, setUserId } = sessionSlice.actions;

export const session = (state) => state.session;

export default sessionSlice.reducer;